import { render, staticRenderFns } from "./RoutedPage.vue?vue&type=template&id=9fa81e2c&"
import script from "./RoutedPage.vue?vue&type=script&lang=ts&"
export * from "./RoutedPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports